import './App.css';
import { Toaster } from 'react-hot-toast';
import UserRoutes from './routes/UserRoutes';
import { Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';

import axios from 'axios';
import { BASE_URL } from './utils/BASE_URL';

function App() {

  useEffect(() => {
    const fetchTheme = async () => {
      try {
        const { data } = await axios.get(`${BASE_URL}/colors`);
        const presets = data?.data;
        if (presets && Array.isArray(presets)) {
          const activePreset = presets.find(
            (p) => p.colors?.isActive === "true" || p.colors?.isActive === true
          );
          if (activePreset && activePreset.colors) {
            const root = document.documentElement;
            Object.entries(activePreset.colors).forEach(([key, value]) => {
              root.style.setProperty(`--color-${key}`, value);
            });
          }
        }
      } catch (error) {
        console.error("Failed to load theme", error);
      }
    };
    fetchTheme();
  }, []);

  return (
    <>
      <Routes>
        <Route path="/*" element={<UserRoutes />} />
      </Routes>
      <Toaster
        position="bottom-left"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          duration: 5000,
          style: {
            background: '#333',
            color: '#fff',
            padding: '16px',
            borderRadius: '10px',
            fontSize: '14px',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#22c55e',
              secondary: '#333',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ff4b4b',
              secondary: '#fff',
            },
          },
        }}
      />
    </>
  );
}

export default App;